export const getBackboneWindow = (): Window => window.OpalFrame ?? window
